(function () {
  var CART_ITEMS_KEY = 'algolia_cart_attributions';
  var QUERY_ID_TTL = 3600000; // Algolia joins a queryID to a conversion only within one hour

  var cfg = window.algoliaConfig || {};
  var PRODUCTS_INDEX = (cfg.index_prefix || 'shopify_') + 'products';

  // search-insights (aa init useCookie:true) stores the anonymous userToken here.
  function cookie(name) {
    try {
      var parts = ('; ' + document.cookie).split('; ' + name + '=');
      return parts.length === 2 ? decodeURIComponent(parts.pop().split(';').shift()) : '';
    } catch (e) { return ''; } // malformed value -> decodeURIComponent throws
  }

  function insightsReady() {
    return typeof window.aa === 'function';
  }

  // Bots never boot Insights (snippets/algolia-config.liquid); wait briefly
  // for the loader on slow pages rather than dropping the first event.
  function whenInsightsReady(cb) {
    if (cfg.is_automation) return;
    if (insightsReady()) { cb(); return; }
    var tries = 0;
    var id = setInterval(function () {
      tries += 1;
      if (insightsReady()) { clearInterval(id); cb(); }
      else if (tries > 100) clearInterval(id); // 5 s
    }, 50);
  }

  var MODEL_LABELS = {
    'bought-together': 'Bought Together',
    'related-products': 'Related',
    'looking-similar': 'Looking Similar',
    'trending-items': 'Trending'
  };
  // Kept in step with SURFACE_LABELS in assets/recs-engine.js so a click and
  // its conversion carry the same surface name.
  var SURFACE_LABELS = {
    pdp: 'PDP', collection: 'Collection', cart: 'Cart', wishlist: 'Wishlist', home: 'Home',
    search: 'Search Panel'
  };

  function recsEventName(attribution) {
    var model = MODEL_LABELS[attribution.model] || 'Recs';
    var surface = SURFACE_LABELS[attribution.surface] || attribution.surface;
    var name = 'Recs ' + model + ' Added To Cart';
    return surface ? name + ' (' + surface + ')' : name;
  }

  // Event name per origin. The two names that pre-date 2026-09-18 are kept
  // as they were so the dashboard history stays continuous.
  function addToCartEventName(attribution) {
    if (!attribution) return 'Product Added To Cart';
    if (attribution.source === 'recs') return recsEventName(attribution);
    if (attribution.source === 'collection') return 'Product Added To Cart (Collection)';
    return 'Product Added to Cart from Search';
  }

  // The add.js response carries the line that was just added, so the cart event
  // can report real revenue rather than a bare object id.
  //
  // Two shapes arrive in detail.cart. product-form.js and both calculators
  // dispatch the /cart/add.js response for a single item, which IS the line
  // item ({variant_id, price, quantity, …}); only the bundle path dispatches
  // {items:[…]}. Reading `.items` alone matched nothing on the ordinary PDP
  // and quick-add paths, so no add-to-cart event had ever carried
  // objectData / value / currency (measured on staging, 2026-09-18).
  function lineFor(detail, variantId) {
    var cart = detail && detail.cart;
    if (!cart) return null;
    if (Array.isArray(cart.items)) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === String(variantId)) return cart.items[i];
      }
      return cart.items[0] || null;
    }
    return cart.variant_id != null ? cart : null;
  }

  // Unit price the shopper actually pays. The AJAX cart reports cents, and
  // `final_price` already has line-level discounts applied where Shopify
  // exposes it; `price` is the undiscounted fallback.
  function unitPriceFor(line) {
    var cents = typeof line.final_price === 'number' ? line.final_price : line.price;
    return typeof cents === 'number' ? cents / 100 : null;
  }

  function currencyFor(detail) {
    return (detail.cart && detail.cart.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';
  }

  /* ------------------------------------------------------------------------
   * Cart map -> hidden cart attributes, for the server-side purchase replay.
   *
   * The Checkout Extensibility thank-you page never runs theme JS, so the
   * storefront cannot fire purchasedObjectIDsAfterSearch itself. Persist the
   * per-variant {queryID, objectID, indexName, clickedAt} map + the anonymous
   * userToken to hidden cart attributes; they ride into order.note_attributes
   * and rs-capi-proxy /webhook/orders-paid replays the purchase event.
   * Underscore-prefixed names keep these out of the customer-facing order view.
   *
   * `t` is the click time: the cart attribute has no TTL and survives to a
   * checkout days later, so the proxy needs the age to decide whether the
   * queryID is still usable. Since 2026-09-18 a line is recorded even without
   * a queryID (`q` omitted) so the proxy can send the whole basket in one
   * purchase event — Frequently Bought Together only trains on conversions
   * with two or more items. The proxy ignores q-less entries until that
   * change ships; they are harmless in the meantime.
   * ---------------------------------------------------------------------- */
  function addCartAttribution(variantId, entry) {
    try {
      var raw = localStorage.getItem(CART_ITEMS_KEY);
      var items = raw ? JSON.parse(raw) : {};
      items[String(variantId)] = {
        queryID: entry.queryID || '',
        objectID: String(entry.objectID),
        indexName: entry.indexName || PRODUCTS_INDEX,
        timestamp: Date.now()
      };
      localStorage.setItem(CART_ITEMS_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function getCartAttributions() {
    try {
      var raw = localStorage.getItem(CART_ITEMS_KEY);
      if (!raw) return {};
      var items = JSON.parse(raw);
      var now = Date.now();
      var valid = {};
      for (var vid in items) {
        if (items[vid].timestamp && (now - items[vid].timestamp) < QUERY_ID_TTL) {
          valid[vid] = items[vid];
        }
      }
      return valid;
    } catch (e) {
      return {};
    }
  }

  function persistAlgoliaAttribution() {
    try {
      var items = getCartAttributions();
      var map = {};
      for (var vid in items) {
        if (!items[vid].objectID) continue;
        var rec = {
          o: items[vid].objectID,
          i: items[vid].indexName,
          t: items[vid].timestamp || Date.now()
        };
        if (items[vid].queryID) rec.q = items[vid].queryID;
        map[vid] = rec;
      }
      if (!Object.keys(map).length) return;
      var attrs = { _algolia_attribution: JSON.stringify(map) };
      var token = cookie('_ALGOLIA');
      if (token) attrs._algolia_user_token = token;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {}); // analytics metadata — fail silent
    } catch (e) {}
  }

  /* ------------------------------------------------------------------------
   * Add to cart.
   *
   * One writer for every surface. The attribution comes from the shared
   * per-objectID map (snippets/algolia-config.liquid): a match on the variant
   * being added, else on its product. That replaces a single last-touch slot
   * which credited the add to whichever product was clicked last.
   *
   * Every add is reported. With a queryID under an hour old it is the
   * AfterSearch event (search / Recommend attribution, revenue analytics);
   * otherwise the plain addedToCartObjectIDs — Frequently Bought Together,
   * Trending, Related products and Personalization all consume it, and
   * Algolia infers the queryID from an earlier click by the same userToken
   * anyway. Previously an add with no fresh attribution sent nothing.
   * ---------------------------------------------------------------------- */
  document.addEventListener('on:cart:add', function (e) {
    var detail = e.detail || {};
    var line = lineFor(detail, detail.variantId);
    var variantId = detail.variantId || (line && line.variant_id);
    if (!variantId) return;
    var productId = line && line.product_id;

    var attribution = window.rsAlgoliaAttribution
      ? window.rsAlgoliaAttribution.lookup(variantId, productId)
      : null;
    var fresh = !!(attribution && attribution.queryID && Date.now() - (attribution.ts || 0) < QUERY_ID_TTL);
    var objectID = attribution ? String(attribution.objectID) : String(variantId);
    var indexName = (attribution && attribution.indexName) || PRODUCTS_INDEX;

    if (insightsReady()) {
      var payload = {
        index: indexName,
        eventName: addToCartEventName(attribution),
        objectIDs: [objectID]
      };
      var price = line ? unitPriceFor(line) : null;
      if (price != null) {
        var quantity = line.quantity || 1;
        payload.objectData = [{ price: price, quantity: quantity }];
        // Rounded so 19.99 × 1 does not go out as 19.990000000000002.
        payload.value = Math.round(price * quantity * 100) / 100;
        payload.currency = currencyFor(detail);
      }
      if (fresh) {
        payload.queryID = attribution.queryID;
        aa('addedToCartObjectIDsAfterSearch', payload);
      } else {
        aa('addedToCartObjectIDs', payload);
      }
    }

    addCartAttribution(variantId, {
      queryID: fresh ? attribution.queryID : '',
      objectID: objectID,
      indexName: indexName
    });
    persistAlgoliaAttribution();

    if (attribution && window.rsAlgoliaAttribution) window.rsAlgoliaAttribution.forget(attribution.objectID);
  });

  /* ------------------------------------------------------------------------
   * Product page view — the "view details" signal Personalization needs and
   * the highest-volume product surface on the site. One event per page load,
   * against the variant the page opened on (records are variant-level).
   * ---------------------------------------------------------------------- */
  function trackProductView() {
    var page = cfg.page;
    if (!page || page.type !== 'product' || !page.objectID) return;
    whenInsightsReady(function () {
      aa('viewedObjectIDs', {
        index: PRODUCTS_INDEX,
        eventName: 'Product Viewed',
        objectIDs: [String(page.objectID)]
      });
    });
  }

  /* ------------------------------------------------------------------------
   * Collection grid — Liquid-rendered, so there is no search to attribute to.
   * Impressions once a card is half visible (batched, ≤20 per event, once per
   * objectID per page), clicks as clickedObjectIDs, and an attribution entry
   * so the add that follows is named for this surface. Cards are re-rendered
   * by facet filtering and pagination; a MutationObserver picks the new ones
   * up. Cards live on <product-card data-algolia-objectid> inside the grid
   * marked data-algolia-surface="collection".
   * ---------------------------------------------------------------------- */
  function trackCollectionGrid() {
    var page = cfg.page;
    if (!page || page.type !== 'collection' || cfg.is_automation) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var GRID_SELECTOR = '[data-algolia-surface="collection"]';
    var CARD_SELECTOR = 'product-card[data-algolia-objectid]';
    var seen = {};
    var pending = [];
    var flushTimer = null;

    function flush() {
      flushTimer = null;
      if (!pending.length) return;
      var batch = pending.splice(0, pending.length);
      whenInsightsReady(function () {
        for (var i = 0; i < batch.length; i += 20) {
          aa('viewedObjectIDs', {
            index: PRODUCTS_INDEX,
            eventName: 'Products Viewed (Collection)',
            objectIDs: batch.slice(i, i + 20)
          });
        }
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var id = entry.target.getAttribute('data-algolia-objectid');
        if (!id || seen[id]) return;
        seen[id] = true;
        pending.push(String(id));
      });
      if (pending.length && !flushTimer) flushTimer = setTimeout(flush, 500);
    }, { threshold: 0.5 });

    function scan() {
      var grids = document.querySelectorAll(GRID_SELECTOR);
      for (var g = 0; g < grids.length; g++) {
        var cards = grids[g].querySelectorAll(CARD_SELECTOR);
        for (var c = 0; c < cards.length; c++) {
          if (cards[c].getAttribute('data-algolia-observed')) continue;
          cards[c].setAttribute('data-algolia-observed', '1');
          io.observe(cards[c]);
        }
      }
    }

    document.addEventListener('click', function (evt) {
      var grid = evt.target.closest(GRID_SELECTOR);
      if (!grid) return;
      var card = evt.target.closest(CARD_SELECTOR);
      if (!card) return;
      var objectID = card.getAttribute('data-algolia-objectid');
      if (!objectID) return;
      var productId = card.getAttribute('data-algolia-productid') || '';

      // Saving to a board or opening the quick-add drawer is not a product
      // click, but the add that follows still came from this grid.
      var utility = evt.target.closest('[data-rs-board-picker], .card__quick-add, .card__compare');
      if (window.rsAlgoliaAttribution) {
        window.rsAlgoliaAttribution.remember({
          objectID: objectID, productId: productId, indexName: PRODUCTS_INDEX, source: 'collection', surface: 'collection'
        });
      }
      if (utility || !insightsReady()) return;
      aa('clickedObjectIDs', {
        index: PRODUCTS_INDEX,
        eventName: 'Product Clicked (Collection)',
        objectIDs: [String(objectID)]
      });
    });

    scan();
    document.addEventListener('on:facet-filters:updated', scan);
    if (typeof MutationObserver !== 'undefined') {
      var rescan = null;
      new MutationObserver(function () {
        if (rescan) return;
        rescan = setTimeout(function () { rescan = null; scan(); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function start() {
    trackProductView();
    trackCollectionGrid();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
